import EDHttp from '../utils/EDHttp';

export default {
  get: function(servicer) {
    return new Promise((resolve, reject) => {
      EDHttp.get(`/servicers/${servicer}`)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  list: function() {
    return new Promise((resolve, reject) => {
      EDHttp.get(`/servicers`)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  add: function(servicer) {
    return new Promise((resolve, reject) => {
      EDHttp.post(`/servicers/create`, servicer)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  update: function(id, servicer) {
    return new Promise((resolve, reject) => {
      EDHttp.put(`/servicers/${id}`, servicer)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  delete: function(id) {
    return new Promise((resolve, reject) => {
      EDHttp.delete(`/servicers/${id}`)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  }
};
